<template>
  <div class="page">
    <div class="appbar">
      <h1 class="appbar-title">Companies</h1>
      <ThemeToggle />
    </div>

    <div v-if="loading" class="state-note">Loading companies…</div>
    <div v-else-if="error" class="state-note error">{{ error }}</div>
    <div v-else-if="companies.length === 0" class="state-note">
      No companies are available for this account.
    </div>

    <ul v-else class="list">
      <li
          v-for="c in companies"
          :key="c.id"
          class="card company-card"
          role="button"
          tabindex="0"
          @click="selectCompany(c.id)"
          @keydown.enter="selectCompany(c.id)"
          @keydown.space.prevent="selectCompany(c.id)"
      >
        <div class="row">
          <span class="company-name">{{ c.name }}</span>
          <i class="fa-solid fa-chevron-right" :style="{ color: 'var(--text-faint)' }"></i>
        </div>

        <div v-if="c.stats" class="stat-row">
          <span
              v-for="s in statuses"
              :key="s.key"
              :class="['stat-chip', s.cls, { 'is-zero': !c.stats[s.key] }]"
              :title="s.title"
          >
            <span class="stat-count">{{ c.stats[s.key] ?? 0 }}</span>
            <span class="stat-label">{{ s.label }}</span>
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { fetchCompanies } from '@/services/ApiService'
import ThemeToggle from './ThemeToggle.vue'

export default {
  name: 'CompanySelect',
  components: { ThemeToggle },
  data() {
    return {
      companies: [],
      loading: true,
      error: null,
      statuses: [
        { key: 'dr', label: 'DR', cls: 'stat-dr', title: 'Driving' },
        { key: 'on', label: 'ON', cls: 'stat-on', title: 'On duty' },
        { key: 'sb', label: 'SB', cls: 'stat-sb', title: 'Sleeper berth' },
        { key: 'off', label: 'OFF', cls: 'stat-off', title: 'Off duty' },
        { key: 'pc', label: 'PC', cls: 'stat-pc', title: 'Personal conveyance' },
        { key: 'ym', label: 'YM', cls: 'stat-ym', title: 'Yard move' },
      ],
    }
  },
  methods: {
    selectCompany(companyId) {
      this.$router.push({ name: 'TruckList', params: { companyId } })
    },
    async load() {
      try {
        this.companies = await fetchCompanies()
        this.error = null
      } catch (e) {
        this.error = e?.message || 'Could not load companies.'
      } finally {
        this.loading = false
      }
    },
  },
  mounted() {
    this.load()
  },
}
</script>

<style scoped>
@import './TruckList.css';
</style>
